import AOS from "aos";
import lax from "lax.js";
import Swiper, {
  Navigation,
  Pagination,
  Controller,
  EffectCards,
  EffectCube,
  Autoplay,
} from "swiper";

(function ($) {
  window.onload = function () {};


  //on document ready scripts start
  $(function () {
    //Buttons
    $(".alm-load-more-btn").addClass("button");
    $(".button").wrapInner('<span class="button__label"></span>');

    //empty link

    $(".empty-link > a").click(function (e) {
      e.preventDefault();
    });

    //Menu
    let menuOpen = false;

    function siteMenuOpen() {
      menuOpen = true;
      $(".site-header").addClass("site-header--active");
      $(".site-header__inner").addClass("site-header__inner--invert");
    }

    function siteMenuClose() {
      menuOpen = false;
      $(".site-header").removeClass("site-header--active");
      $(".site-header__inner").removeClass("site-header__inner--invert");
    }

    $(".site-toggle--menu").click(function () {
      if (menuOpen) {
        siteMenuClose();
      } else {
        siteMenuOpen();
      }

      if (searchOpen) {
        searchBarClose();
      }
    });

    //Search
    let searchOpen = false;

    function searchBarOpen() {
      searchOpen = true;
      $(".site-toggle--search").addClass("site-toggle--search-active");
      $(".search-bar").fadeIn(300);

      //$(".site-header .site-logo, .site-header__cta-btn-wrap").fadeOut(300);
      $(".new-menu-container").fadeOut(10); //russ
      $(".search-container").css("width", "100%");

      $(".search__input").focus();

    }

    function searchBarClose() {
      searchOpen = false;
      $(".site-toggle--search").removeClass("site-toggle--search-active");
      //$(".site-header .site-logo, .site-header__cta-btn-wrap").fadeIn(300);
      $(".new-menu-container").fadeIn(300); //russ
      $(".search-container").css("width", "0%");
      $(".search-bar").fadeOut(1);

    }

    $(".site-toggle--search").click(function () {
      if (searchOpen) {
        searchBarClose();
      } else {
        searchBarOpen();
      }

      if (menuOpen) {
        siteMenuClose();
      }
    });

    //Wrap Iframes
    $(".entry-content__article iframe").wrap("<div class='iframe-wrap'></div>");

    //Popup
    let popupOpen = false;
    $(".bg-clip__open-popup").on("click", function (e) {
      popupOpen = true;
      e.preventDefault();

      $(".bg-clip__popup video").trigger("play");
      $(".bg-clip__popup").fadeIn(300);
    });

    //watch button popup
    let watchpopupOpen = false;
    $(".watchbutton-bg-clip__open-popup").each(function(index){

    $(this).on("click", function (e) {
      watchpopupOpen = true;
      e.preventDefault();

      //alert(index);
      let popuplist = document.getElementsByClassName('bg-clip__popup');
      //alert(popuplist.item(index));
      //alert($(this).parent().parent().parent().attr());


      //popuplist.item(index).trigger("play");
      //popuplist.item(index).fadeIn(300);
      //$(".bg-clip__popup video").index(index).trigger("play");
      $(popuplist[index]).fadeIn(300);
      //$(".bg-clip__popup video").trigger("play");
      //$(".bg-clip__popup").fadeIn(300);
    });

  });

    function afterClosePopup() {
      popupOpen = false;
      $(".bg-clip__popup iframe").each(function () {
        let src = $(this).attr("src");
        $(this).attr("src", src);
      });
    }
    function afterClosePopupHome() {
      popupOpen = false;
      $(".bg-clip__popup iframe").each(function () {
        let src = $(this).attr("src");

        $(this).contents().find('video')[0].pause();
      });
    }

    $(".bg-clip__popup-overlay, .site-toggle--close-popup").on(
      "click",
      function () {
        if(window.location.pathname == '/'){
          afterClosePopupHome();
        }
        else{
          afterClosePopup();
        }

        $(".bg-clip__popup").fadeOut(300);

      }
    );

    $(document).keydown(function (e) {
      if (e.which == 27 && popupOpen) {
        afterClosePopup();
        $(".bg-clip__popup").fadeOut(300);
      }
    });

    // Progress Bar
    window.onscroll = function () {
      progressBar();
    };

    function progressBar() {
      let bar = document.getElementById("progress-bar__bar");
      if (bar) {
        let winScroll =
          document.body.scrollTop || document.documentElement.scrollTop;
        let height =
          // document.documentElement.scrollHeight -
          $(".entry-content").outerHeight() -
          document.documentElement.clientHeight;
        let scrolled = (winScroll / height) * 100;
        bar.style.width = scrolled + "%";
      }
    }

    //Ticker
    function ticker() {
      let speed = 7000;
      $(".ticker__item").each(function () {
        let tickeritemWidth = $(this).outerWidth();
        $(".ticker").animate(
          {
            zIndex: -tickeritemWidth,
          },
          {
            duration: speed,
            easing: "linear",
            step: function (now) {
              $(this).css("transform", "translateX(" + now + "px)");
            },
            complete: function () {
              $(this)
                .css({
                  transform: "translateX(0)",
                })
                .find("li:last")
                .after($(this).find("li:first"));
              ticker();
            },
          }
        );
      });
    }
    $(window).on("load", function () {
      ticker();
      if(window.location.pathname == '/'){
        afterClosePopupHome();
      }
    });

    //Custom Select
    $("select").wrap('<div class="select"></div>');

    // scroll to anchor
    $("a").on("click", function (e) {
      let target = this.hash;
      let $target = $(target);
      let excludeHeader = $(this).hasClass("exclude-header");
      if (target && $target.length) {
        e.preventDefault();
        $("html, body")
          .stop()
          .animate(
            {
              scrollTop: excludeHeader
                ? $target.offset().top
                : $target.offset().top - $(".site-header").outerHeight() * 1.5,
            },
            900,
            "swing"
          );
      }
    });

    // Move Elements
    $(document).on("mousemove", function (e) {
      let ratio = 75;
      let x = e.pageX / ratio;
      let y = e.pageY / ratio;
      $(".decor__inner").css("transform", `translate(${x}px, ${y}px)`);
    });

    //Change Menu Colors
    $(".site-menu a").hover(
      function () {
        let color = $(this).find(".site-header__color");
        if (color) {
          $(".site-header__menu").css({
            "--accent-color": color.data("accent-color"),
            "--primary-color": color.data("primary-color"),
          });
        }
      },
      function () {
        $(".site-header__menu").css({
          "--accent-color": $(".site-header__menu").data("accent-color"),
          "--primary-color": $(".site-header__menu").data("primary-color"),
        });
      }
    );

    //Add class to header after scroll
    $(window).on("scroll load", function () {

      if (this.scrollY > 1) {
        $(".site-header").addClass("site-header--sticky");
        $("header .new-menu > li:last-child > a").addClass("header_button_contact_texture");
      } else {
        $(".site-header").removeClass("site-header--sticky");
        $("header .new-menu > li:last-child > a").removeClass("header_button_contact_texture");
      }
    });


    // Start iPad and iPhone dectection
    //if((navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) || navigator.platform === 'iPad' || navigator.platform === 'iPhone' || /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)){
    if((navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) || navigator.platform === 'iPad' || navigator.platform === 'iPhone' || /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)){
        if(!/Android/i.test(navigator.userAgent)){
          $('.parallax').each(function(){
              $(this).addClass("nonparallax");
          });

          $('.custom_iframe_video').each(function(){
              $(this).addClass("custom_iframe_video_ipad")
              $(this).removeClass("custom_iframe_video")
          });
        }


        $('.watch_button_container').each(function(){
               $(this).addClass("watch_button_container_nonparallax");
        });

        $('.custom_headervideo_overlay').each(function(){
               $(this).addClass("alwaysVisible");
        });


    }

    //for iPad iFrame
    $(".custom_iframe_video").on("load", function(){
      let head = $(this).contents().find("head")
      let css = '<style> video{object-fit:cover; width:100%; height:100%;} html{overflow: auto;} html,body,div,iframe {margin: 0px; padding: 0px; height: 100%; border: none;} iframe{display: block; width: 100%; border: none; overflow-y: auto; overflow-x: hidden;}} </style>';
      //let css = '<style>  </style>';
      $(head).append(css);

    });
    $(".custom_iframe_video_ipad").on("load", function(){
      let head = $(this).contents().find("head")
      let css = '<style> video{min-width:100vw !important; min-height:100vh !important; --inline-controls-bar-height:100vh !important;} html{overflow: auto;} html,body,div,iframe {margin: 0px; padding: 0px; height: 100%; border: none;} iframe{display: block; width: 100%; border: none; overflow-y: auto; overflow-x: hidden;}} </style>';
      //let css = '<style>  </style>';
      let script = '<script>(function ($) {window.onload = function () {};  $(".media-document").each(function(){  $(this).removeClass("media-document")  }); })(jQuery, this);</script>';
      // let script = '<script>$(".media-document").on("load", function(){  $(this).removeClass("media-document")  });</script>';
      //let script = '<script> $(document).ready(function(){ $(".media-document audio ipad").removeClass("media-document") })</script>';
      //let script = '<script> video.classList.remove("media-document")</script>';
      //let script = '<script> Target = document.getElementsByClassName("media-document")[1]; Target.className=""; </script>';



      $(head).append(css);
      $(head).append(script);


    });




    //Search Filter
    let div = document.getElementById("search-dropdown");

    if ($(div).length > 0) {
      let animationSpeed = 100;
      const noResultsClass = "search-dropdown__no-results";
      const noResults =
        "<li class=" +
        noResultsClass +
        " hidden><span class='search-dropdown__label'>No results found. <a href='#' class='search-dropdown__clear'>Clear</a></span></li>";

      $(".search-dropdown__ul").append(noResults);

      let a = $("li > a", div);
      let input = document.getElementById("search-dropdown__input");

      function filterFunction() {
        let filter = input.value.toUpperCase();
        for (let i = 0; i < a.length; i++) {
          let txtValue = a[i].textContent || a[i].innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            $(a[i].parentElement).show(animationSpeed);
          } else {
            $(a[i].parentElement).hide(animationSpeed);
          }
        }
      }

      function filterFunctionResult() {
        setTimeout(function () {
          if (
            $(".search-dropdown__ul").children(".menu-item:visible").length ===
            0
          ) {
            $("." + noResultsClass).show(animationSpeed);
          } else {
            $("." + noResultsClass).hide(animationSpeed);
          }
        }, animationSpeed + 10);
        filterFunction();
      }

      input.addEventListener("keyup", function (event) {
        filterFunctionResult();
      });

      $(".search-dropdown__clear").click(function (event) {
        event.preventDefault();
        $(".search-dropdown__input").val("").focus();
        filterFunctionResult();
      });
    }

    //Sticky Sidebar
    if ($(".sidebar--sticky").length > 0) {
      let stickySidebar = new Sticksy(".sidebar--sticky", {
        topSpacing: $(".site-header").outerHeight() * 1.25,
        listen: true,
      });
    }

    /*
    Swiper Start
    */

    const navigationSettings = {
      nextEl: ".site-carousel__btn--next",
      prevEl: ".site-carousel__btn--prev",
    };

    const navigationSettingslvl1 = {
      nextEl: ".site-carousel--work1 .site-carousel__btn--next",
      prevEl: ".site-carousel--work1 .site-carousel__btn--prev",
    };
    const navigationSettingslvl2 = {
      nextEl: ".site-carousel--work2 .site-carousel__btn--next",
      prevEl: ".site-carousel--work2 .site-carousel__btn--prev",
    };

    //Sync Slider
    $(".site-carousel--sync").each(function (index, element) {
      let swiperText = new Swiper($(".swiper-sync--text", this)[0], {
        modules: [Navigation, Pagination, Controller, EffectCube, Autoplay],
        // effect: "cube",
        grabCursor: true,
        speed: 500,
        cubeEffect: {
          shadow: false,
          slideShadows: false,
        },
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        navigation: navigationSettings,
        autoplay: {
          delay: 5000,
        },
      });

      let swiperImage = new Swiper($(".swiper-sync--image", this)[0], {
        modules: [Controller, EffectCards, Autoplay],
        speed: 500,
        effect: "cards",
        cardsEffect: {
          slideShadows: false,
        },
        grabCursor: true,
        loop: true,
        grabCursor: true,
      });

      swiperText.controller.control = swiperImage;
      swiperImage.controller.control = swiperText;
    });

    //Autoplay Slider - Logos
    $(".site-carousel--gallery").each(function (index, element) {
      var swiper = new Swiper(element, {
        loop: true,
        allowTouchMove: false,
        modules: [Autoplay],
        slidesPerView: $(this).data("quantity-mobile"),
        breakpoints: {
          700: {
            slidesPerView: $(this).data("quantity-tablet"),
          },
          1500: {
            slidesPerView: $(this).data("quantity-desktop"),
          },
        },
        speed: 4000,
        spaceBetween: 50,
        autoplay: {
          delay: 0,
        },
      });
    });

    
    //Animation Carousel
     $(".site-carousel--Animation1").each(function (index, element) {
      let swiperHeader = new Swiper($(".swiper-sync--headercard1", this)[0], {
      //var swiper = new Swiper(element, {
        modules: [Navigation],
        loop: false,
        allowTouchMove: false,
        grabCursor: false,
        slidesPerView: $(this).data("quantity-mobile"),
        breakpoints: {
          700: {
            slidesPerView: $(this).data("quantity-tablet"),
          },
          1500: {
            slidesPerView: $(this).data("quantity-desktop"),
          },
        },
        navigation: navigationSettingslvl1,
        spaceBetween: 0,
        speed: 1000,
        autoplay: {
          delay: 0,
        },
      });
    });

    $(".site-carousel--Animation2").each(function (index, element) {
      let swiperHeader = new Swiper($(".swiper-sync--headercard2", this)[0], {
      //var swiper = new Swiper(element, {
        modules: [Navigation],
        loop: false,
        allowTouchMove: false,
        grabCursor: false,
        slidesPerView: $(this).data("quantity-mobile"),
        breakpoints: {
          700: {
            slidesPerView: $(this).data("quantity-tablet"),
          },
          1500: {
            slidesPerView: $(this).data("quantity-desktop"),
          },
        },
        navigation: navigationSettingslvl1,
        spaceBetween: 0,
        speed: 1000,
        autoplay: {
          delay: 0,
        },
      });
    });

    //Work carousel
    $(".site-carousel--work1").each(function (index, element) {
      let swiperHeader = new Swiper($(".swiper-sync--headercard1", this)[0], {
      //var swiper = new Swiper(element, {
        modules: [Navigation],
        loop: true,
        allowTouchMove: true,
        grabCursor: true,
        slidesPerView: $(this).data("quantity-mobile"),
        breakpoints: {
          700: {
            slidesPerView: $(this).data("quantity-tablet"),
          },
          1500: {
            slidesPerView: $(this).data("quantity-desktop"),
          },
        },
        navigation: navigationSettingslvl1,
        spaceBetween: 0,
        speed: 1000,
        autoplay: {
          delay: 0,
        },
      });
    });

    $(".site-carousel--work2").each(function (index, element) {
      let swiperHeader = new Swiper($(".swiper-sync--headercard2", this)[0], {
      //var swiper = new Swiper(element, {
        modules: [Navigation],
        loop: true,
        allowTouchMove: true,
        grabCursor: true,
        slidesPerView: $(this).data("quantity-mobile"),
        breakpoints: {
          700: {
            slidesPerView: $(this).data("quantity-tablet"),
          },
          1500: {
            slidesPerView: $(this).data("quantity-desktop"),
          },
        },
        navigation: navigationSettingslvl2,
        spaceBetween: 0,
        speed: 1000,
        autoplay: {
          delay: 0,
        },
      });
    });

    //Cube Slider
    let cubeSlider = new Swiper(".site-slider--cube", {
      modules: [Navigation, EffectCube, Autoplay],
      effect: "cube",
      grabCursor: true,
      speed: 500,
      cubeEffect: {
        shadow: false,
        slideShadows: false,
      },
      loop: true,
      slidesPerView: 1,
      navigation: navigationSettings,
      autoplay: {
        delay: 3000,
      },
    });

    //Cube Slider Vertical
    let cubeSliderVertical = new Swiper(".site-carousel--team", {
      modules: [Navigation, Autoplay],
      maxBackfaceHiddenSlides: 1,
      loop: true,
      slidesPerView: 1,
      navigation: navigationSettings,
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
        800: {
          slidesPerView: 3,
        },
        1500: {
          slidesPerView: 5,
        },
      },
    });

    /*
    Swiper End
    */

    //Accordion
    $(".accordion__button").on("click", function () {
      $(this).removeClass("on");
      $(this).next().slideUp("normal");
      if ($(this).next().is(":hidden") == true) {
        $(this).addClass("on");
        $(this).next().slideDown("normal");
      }
    });
    $(".accordion__content").hide();

    //IE Message
    if (window.document.documentMode) {
      let currentDiv = document.getElementById("site-body");
      currentDiv.insertAdjacentHTML(
        "afterbegin",
        '<div class="ie-message">⚠️You are using an outdated Internet Explorer browser. For a faster, safer browsing experience, upgrade for FREE today! <a href="https://www.microsoft.com/en-us/edge" target="_blank" class="btn">Upgrade</a></div>'
      );
    }

    //Animation on scroll
    AOS.init({
      once: true,
      duration: 1000,
      offset: 70,
    });

    //Gravity Forms
    //refresh aos after gravity form submit
    $(document).on("gform_confirmation_loaded", function () {
      AOS.refresh();
    });

    //Lax
    lax.init();

    lax.addDriver(
      "scrollY",
      function () {
        return document.documentElement.scrollTop;
      },
      { frameStep: 1 }
    );

    lax.addElements(".decor__wrap", {
      scrollY: {
        translateY: [
          ["elInY", "elOutY"],
          [-100, 100],
        ],
      },
    });

    lax.addElements(".decor__img", {
      scrollY: {
        rotate: [
          ["elInY", "elOutY"],
          [0, 360],
        ],
      },
    });

    lax.addElements(".scrollY", {
      scrollY: {
        translateY: [
          ["elInY", "elOutY"],
          {
            700: [100, -100],
            1000: [150, -150],
            1500: [200, -200],
          },
        ],
      },
    });

    lax.addElements(".bg-clip__overlay", {
      scrollY: {
        translateY: [
          ["elInY", "elCenterY"],
          {
            700: [-200, 0],
            1000: [-300, 0],
            1500: [-500, 0],
          },
        ],
      },
    });

    $(".decor__img").animate({ opacity: "1" });

// Start Section Parallax

//
// $('.img-parallax').each(function(){
//   var img = $(this);
//   var imgParent = $(this).parent();
//
//   // alert("img: "+img);
//   // alert("imgParent: "+imgParent);
//
//   function parallaxImg () {
//
//
//
//     var speed = img.data('speed');
//     var imgY = imgParent.offset().top;
//     var winY = $(this).scrollTop();
//     var winH = $(this).height();
//     var parentH = imgParent.innerHeight();
//     //alert("parentH: "+parentH);
//
//
//     // The next pixel to show on screen
//     var winBottom = winY + winH;
//     alert("img speed data: "+speed+ ", winBottom: "+winBottom+", winY: "+winY+", winH: "+winH+", imgY: "+imgY);
//
//     // If block is shown on screen
//   //  alert("check if: " + winBottom+">"+imgY+" && "+winY+"<"+imgY+"+"+parentH+"=="+ (winBottom > imgY && winY < imgY + parentH) );
//     if (winBottom > imgY && winY < imgY + parentH) {
//     //  alert("entered if: " + winBottom+">"+imgY+" && "+winY+"<"+imgY+"+"+parentH+"=="+ (winBottom > imgY && winY < imgY + parentH) );
//
//       // Number of pixels shown after block appear
//       var imgBottom = ((winBottom - imgY) * speed);
//       // Max number of pixels until block disappear
//       var imgTop = winH + parentH;
//       // Porcentage between start showing until disappearing
//       var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
//
//       alert("imgBottom: "+imgBottom+"-"+"imgTop: "+imgTop+"-"+"imgPercent: "+imgPercent+"-"+"speed: "+speed);
//
//     }
//     // img.css({
//     //   top: imgPercent + '%',
//     //   transform: 'translate(-50%, -' + imgPercent + '%)'
//     // });
//     img.css("top",imgPercent + '%');
//     img.css("transform",'translate(-50%, -' + imgPercent + '%)');
//
//
//
//   }
//
//   $(document).on({
//     scroll: function () {
//
//       parallaxImg();
//
//     }, ready: function () {
//       //  alert("parallax");
//       parallaxImg();
//
//     }
//   });
//
// });

//End Section Parallax

$('.img-parallax').each(function(){
  var img = $(this);
  var imgParent = $(this).parent();
  function parallaxImg () {
    var speed = img.data('speed');
    var imgY = imgParent.offset().top;
    var winY = img.scrollTop();
    var winH = img.height();
    var parentH = imgParent.innerHeight();


    // The next pixel to show on screen
    var winBottom = winY + winH;
 //alert("img speed data: "+speed+ ", winBottom: "+winBottom+", winY: "+winY+", winH: "+winH+", imgY: "+imgY);
    // If block is shown on screen
    if (winBottom > imgY && winY < imgY + parentH) {
      // Number of pixels shown after block appear
      var imgBottom = ((winBottom - imgY) * speed);
      // Max number of pixels until block disappear
      var imgTop = winH + parentH;
      // Porcentage between start showing until disappearing
      var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
      // alert("imgBottom: "+imgBottom+"-"+"imgTop: "+imgTop+"-"+"imgPercent: "+imgPercent+"-"+"speed: "+ speed);
    }
    img.css("top",imgPercent + '%');
    img.css("transform",'translate(-50%, -' + imgPercent + '%)');
  }
  $(document).on({
    scroll: function () {
      parallaxImg();
    }, ready: function () {
      parallaxImg();


    }



  });
});



    $(window).on('orientationchange', function(event) {

        if((navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) || navigator.platform === 'iPad' || navigator.platform === 'iPhone' || /iPhone|iPad/i.test(navigator.userAgent))
        {

          if(Math.abs(orientation)!=90){
            $('.custom_iframe_video_ipad').each(function(){
                $(this).addClass("custom_iframe_video_ipad_portrait");

            });


          }
          else{
            $('.custom_iframe_video_ipad').each(function(){
              $(this).removeClass("custom_iframe_video_ipad_portrait");
            });

          }
        }
        else{

        }
    });



  }); //on document ready scripts END
})(jQuery, this);
